<div [style.overflow]="'auto'">
	<table mat-table [dataSource]="dataSource" matSort appAnnounceSortChange>
		<ng-container matColumnDef="ciChargeNumber">
			<th mat-header-cell *matHeaderCellDef>
				<div mat-sort-header sortActionDescription="Sort by EEOC number">EEOC Number</div>
			</th>
			<!-- This lead column is a th in order to read this column to the user when they are tabbing through the table -->
			<th mat-cell *matCellDef="let row" class="lead-col mat-mdc-cell">
				{{ row.ciChargeNumber }}
			</th>
		</ng-container>

		<ng-container matColumnDef="rspName">
			<th mat-header-cell *matHeaderCellDef>
				<div mat-sort-header sortActionDescription="Sort by respondent">Respondent</div>
			</th>
			<td mat-cell *matCellDef="let row">{{ row.rspName }}</td>
		</ng-container>

		<ng-container matColumnDef="alStatuteShortName">
			<th mat-header-cell *matHeaderCellDef>
				<div mat-sort-header sortActionDescription="Sort by statute">Statute</div>
			</th>
			<td mat-cell *matCellDef="let row" class="allegation-display">
				{{ displayAllegations(row, 'alStatuteShortName') }}
			</td>
		</ng-container>

		<ng-container matColumnDef="alBasisShortName">
			<th mat-header-cell *matHeaderCellDef>
				<div mat-sort-header sortActionDescription="Sort by basis">Basis</div>
			</th>
			<td mat-cell *matCellDef="let row" class="allegation-display">
				{{ displayAllegations(row, 'alBasisShortName') }}
			</td>
		</ng-container>

		<ng-container matColumnDef="alIssueShortName">
			<th mat-header-cell *matHeaderCellDef>
				<div mat-sort-header sortActionDescription="Sort by issue">Issue</div>
			</th>
			<td mat-cell *matCellDef="let row" class="allegation-display">
				{{ displayAllegations(row, 'alIssueShortName') }}
			</td>
		</ng-container>

		<ng-container matColumnDef="pchpAssessments">
			<th mat-header-cell *matHeaderCellDef>
				<div mat-sort-header sortActionDescription="Sort by PCHP">PCHP</div>
			</th>
			<td mat-cell *matCellDef="let row">{{ displayPCHPAssessments(row) }}</td>
		</ng-container>

		<ng-container matColumnDef="ciAcctOfficeDescription">
			<th mat-header-cell *matHeaderCellDef>
				<div mat-sort-header sortActionDescription="Sort by accountable office">Accountable Office</div>
			</th>
			<td mat-cell *matCellDef="let row">{{ row.ciAcctOfficeDescription }}</td>
		</ng-container>

		<ng-container matColumnDef="chargeAssignments">
			<th mat-header-cell *matHeaderCellDef>
				<div mat-sort-header sortActionDescription="Sort by assigned to">Assigned to</div>
			</th>
			<td mat-cell *matCellDef="let row">{{ displayAssignedTo(row) }}</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
		<tr class="mat-table-row" mat-row *matRowDef="let row; columns: displayColumns"></tr>
	</table>
</div>
<div
	*ngIf="systemicCaseCharges && systemicCaseCharges.length === 0"
	class="margin-left-20 margin-top-10 margin-bottom-10"
>
	No records found.
</div>
<mat-paginator [hidePageSize]="true" [showFirstLastButtons]="true" [pageSize]="10" id="shared-sys-src-cs-tb-paginator"></mat-paginator>
